import { Provider } from '@angular/core';
import {
  DictionaryEntry,
  DYNAMIC_CONFIG_TOKEN,
} from 'libs/platform/dynamic-components/src/lib/services/config-fetchers/fetch-config-from-code.service';

import { puma } from './puma';

const pumaConfigs: DictionaryEntry[] = [
  ['puma:added-to-basket-notification', [puma.addedToBasketNotification]],
  [
    'puma:added-to-basket-notification-pane',
    [puma.addedToBasketNotificationPane],
  ],
  ['puma:checkout', [puma.checkout]],
  ['puma:cbasket-spotlight', [puma.spotlight]],
  ['puma:square-panel-from-list', puma.squarePanelFromList],
  [
    'puma:square-panel-from-list-single-product',
    puma.squarePanelFromListSingleProduct,
  ],
  [
    'puma:horizontal-scrollable-panel-bought-this-season',
    puma.horizontalScrollablePanelBoughtThisSeason,
  ],
  [
    'puma:square-panel-best-performing-articles',
    puma.squarePanelFromRecommendationsBestPerformingArticles,
  ],
  [
    'puma:square-panel-best-performing-articles-global',
    puma.squarePanelFromRecommendationsBestPerformingArticlesGlobal,
  ],
  ['puma:search-products', [puma.searchProducts]],
  ['puma:square-panel-from-search', puma.squarePanelFromSearch],
  ['puma:banner-with-button', [puma.bannerWithButton]],
  [
    'puma:horizontal-scrollable-panel-products-on-the-way',
    puma.horizontalScrollablePanelProductsOnTheWay,
  ],
  [
    'puma:horizontal-scrollable-panel-from-list',
    puma.horizontalScrollablePanelFromList,
  ],
];

export const pumaConfigsInjectionTokenProvider: Provider = {
  provide: DYNAMIC_CONFIG_TOKEN,
  useValue: pumaConfigs,
  multi: true,
};
